import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import { formatAbsolute, formatRelative } from "../common/hooks";

const EVENT_COLORS = {
  CREATED: "#1976d2",
  PRECHECK_STARTED: "#1976d2",
  PRECHECK_FAILED: "#f57f17",
  NEEDS_INPUTS: "#c62828",
  PERMS_DENIED: "#b71c1c",
  DRY_RUN_READY: "#e65100",
  APPROVED: "#2e7d32",
  IN_PROGRESS: "#1976d2",
  RUNNING: "#1976d2",
  COMPLETED: "#388e3c",
  SUCCEEDED: "#388e3c",
  FAILED: "#c2185b",
  CANCELLED: "#616161",
};

const dotFor = (event) => EVENT_COLORS[event] || "#9e9e9e";

/**
 * Audit history rendered as a single-column vertical timeline.
 * Most recent event is at the bottom (per the integration guide).
 */
const Timeline = ({ events }) => {
  if (!events || events.length === 0) {
    return (
      <Typography variant="caption" color="text.secondary">
        No history yet.
      </Typography>
    );
  }
  return (
    <Box sx={{ position: "relative", pl: 2.5 }}>
      <Box
        sx={{
          position: "absolute",
          left: 6,
          top: 6,
          bottom: 6,
          width: 2,
          backgroundColor: "grey.200",
        }}
      />
      {events.map((ev, idx) => {
        const body = ev.message || ev.note;
        const actionable = Boolean(ev.customer_actionable);
        return (
          <Box key={idx} sx={{ position: "relative", pb: 2 }}>
            <Box
              sx={{
                position: "absolute",
                left: -16,
                top: 4,
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: dotFor(ev.event),
                border: "2px solid white",
                boxShadow: "0 0 0 2px rgba(0,0,0,0.06)",
              }}
            />
            <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, flexWrap: "wrap" }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {ev.event?.replace(/_/g, " ")}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {ev.actor || "system"} · {formatRelative(ev.at)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {formatAbsolute(ev.at)}
              </Typography>
            </Box>
            {actionable && body && (
              <Alert severity="warning" sx={{ mt: 1, py: 0.5, fontSize: 13 }}>
                {body}
              </Alert>
            )}
            {!actionable && body && (
              <Typography variant="caption" sx={{ display: "block", mt: 0.25, color: "text.primary" }}>
                {body}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default Timeline;
